import Rest from '@/services/Rest'
import ModelService from '@/services/ModelService'
import ProfileService from '@/services/ProfileService'
import DocumentTypeService from '@/services/DocumentTypeService'
import ProcedureAndPatientDetailService from '@/services/ProcedureAndPatientDetailService'
import PatientConstraintService from '@/services/PatientConstraintService'
import CompanyService from '@/services/CompanyService'
import GeneratedDocumentIdService from '@/services/GeneratedDocumentIdService'

const modelService = ModelService.build()
const profileService = ProfileService.build()
const documentTypeService = DocumentTypeService.build()
const procedureAndPatientDetailService = ProcedureAndPatientDetailService.build()
const patientConstraintService = PatientConstraintService.build()
const companyService = CompanyService.build()
const generatedDocumentIdService = GeneratedDocumentIdService.build()

/**
 * @typedef {DashboardService}
 */
export default class DashboardService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/'


  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  statistics() {
    return generatedDocumentIdService.statistics()
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  modelsList() {
    return modelService.search()
  }


  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  profilesList() {
    return profileService.search()
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  documentTypeList() {
    return documentTypeService.search()
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  procedureAndPatientDetailList() {
    return procedureAndPatientDetailService.search()
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  patientConstraintList() {
    return patientConstraintService.search()
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  companyList() {
    return companyService.search()
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  generatedDocumentCount() {
    return generatedDocumentIdService.count()
  }

}
